import React from "react";
import { Box, Typography } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";

import useModules from "../hooks/useModules";
import BREHomeSummary from "../features/home-dashboard/BREHomeSummary";
import ProspectingHomeSummary from "../features/home-dashboard/ProspectingHomeSummary";
import RecentItems from "../features/home-dashboard/RecentItems";
import TaskList from "../features/tasks/TaskList";

const BRAND_BLUE = "#00336C";
const BRAND_GREEN = "#648315";
const PAGE_BG = "#f7f9fc";

function Home() {
  useOutletContext();

  const { hasComponent } = useModules();
  const hasBRE = hasComponent(["bre.companies", "bre.contacts"]);
  const hasProspecting = hasComponent([
    "prospecting.companies",
    "prospecting.contacts",
    "prospecting.website_visits",
    "prospecting.weekly_prospects",
  ]);

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", backgroundColor: PAGE_BG, pb: 4 }}>
      {/* ===== Sticky Header — matches Metrics ===== */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 5,
          borderBottom: "1px solid #dce4ef",
          background: "#ffffff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
            px: { xs: 2, md: 3 },
            py: 1.75,
          }}
        >
          {/* Left: icon + title */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              sx={{
                width: 38,
                height: 38,
                borderRadius: 2,
                background: BRAND_GREEN,
                color: "#ffffff",
                display: "grid",
                placeItems: "center",
                flex: "0 0 auto",
              }}
            >
              <DashboardIcon sx={{ fontSize: 22 }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  color: BRAND_BLUE,
                  fontSize: 23,
                  fontWeight: 800,
                  lineHeight: 1.05,
                }}
              >
                Dashboard
              </Typography>
              <Typography sx={{ color: "#3a5c08", fontSize: 13.5, mt: 0.35, fontFamily: "'DM Sans', sans-serif", fontWeight: 500, letterSpacing: 0.3 }}>
                Platform activity at a glance
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* ===== Content Area ===== */}
      <Box sx={{ px: { xs: 2, md: 3 } }}>
        {/* CRM Signals Section */}
        {(hasBRE || hasProspecting) && (
          <Box
            sx={{
              mt: 3,
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: hasBRE && hasProspecting ? "1fr 1fr" : "1fr",
              },
              gap: 2.5,
            }}
          >
            {hasBRE && <BREHomeSummary />}
            {hasProspecting && <ProspectingHomeSummary />}
          </Box>
        )}

        {/* Tasks & Recent Activity Section */}
        <Box
          sx={{
            mt: 2.5,
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: 2.5,
          }}
        >
          <TaskList />
          <RecentItems />
        </Box>
      </Box>
    </Box>
  );
}

export default Home;
